import deepCopy from 'lib/deepCopy';

/**
 * Generic utility to ensure an object is mutable by creating a deep copy if it's immutable.
 * Mainly used to handle data from GraphQL/Apollo Client Cache which returns immutable objects.
 * Since Apollo Client freezes all levels of an object, we only need to check the top-level object for immutability.
 *
 * Note: Apollo Client only freezes objects in development mode. But we need to ensure the object
 * is deep copied in production as well to prevent accidental mutation of cached objects.
 */
export default function ensureMutable<T>(obj: T): T;
export default function ensureMutable<T>(obj?: T | null): T | undefined | null;
export default function ensureMutable<T>(obj?: T | null): T | undefined | null {
  if (obj == null || typeof obj !== 'object') {
    return obj;
  }

  if (Object.isFrozen(obj) || !Object.isExtensible(obj)) {
    return deepCopy(obj);
  }

  return obj;
}
